import banner from "./images/Banner.jpg";
import jobimage from "./images/company.png"
export const careerData = {
  image: banner,
  tageline: `Elevate Your Career`,
  // crad title
  title: `Latest Career Listings`,
  subtitle: `Here’s the most recent listed jobs.`,
  Jobs: [
    
  ],
};
